webpackJsonp([95981745539941],{

/***/ 1949:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductManufacturerPage","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"entries","type":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"ProductManufacturer","ofType":null}}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"metadata","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Cursor","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-product-manufacturer-page-38d8b6286365111d3037.js